import React from 'react';
import { GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid';

interface Props {
	enableExport?: boolean;
	quickFilterParser?: (input: string) => string[];
}

export default function AdminQuickFilterToolbar({
	enableExport = true,
	quickFilterParser,
}: Props) {
	return (
		<GridToolbarContainer sx={{ justifyContent: enableExport ? 'space-between' : 'flex-start' }}>
			<GridToolbarQuickFilter quickFilterParser={quickFilterParser} sx={{ pb: 1 }} />
			{enableExport && (
				<GridToolbarExport
					csvOptions={{ allColumns: true, utf8WithBom: true }}
					printOptions={{ disableToolbarButton: true }}
				/>
			)}
		</GridToolbarContainer>
	);
}
